var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNovicashStorePin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 54,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9683 7.40846C32.8863 3.19851 27.5699 0.878906 22.0001 0.878906C16.4251 0.878906 11.1087 3.19851 7.02407 7.41113C2.8781 11.6877 0.601158 17.4334 0.779794 23.1765C1.28371 39.451 20.4537 52.1235 21.2723 52.6541L21.9895 53.1207L22.7147 52.6621C23.5305 52.1449 42.714 39.779 43.2205 23.1738C43.3965 17.4334 41.1169 11.6851 36.9683 7.40846Z",
    fill: "#202735"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40991 21.9651C7.40991 30.0106 13.957 36.5526 22.0025 36.5526C30.048 36.5526 36.5899 30.0106 36.5899 21.9651C36.5899 13.9194 30.048 7.37207 22.0025 7.37207C13.957 7.37207 7.40991 13.9194 7.40991 21.9651Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7593 19.9191L30.3509 31.4003C30.3123 31.7391 30.0508 31.9619 29.6764 31.9619H23.9209C23.5465 31.9619 23.3564 31.7747 23.3564 31.4776V31.4003L24.7737 19.7319C24.848 19.2862 24.9193 18.8435 24.9193 18.3978C24.9193 17.7293 24.848 17.3162 24.6251 17.0191C24.328 16.612 23.808 16.4635 23.1009 16.4635C22.0965 16.4635 20.7565 16.6477 20.7565 16.6477L18.9351 31.3974C18.8994 31.7361 18.6409 31.9589 18.2695 31.9589H12.5021C12.1337 31.9589 11.9495 31.7717 11.9495 31.4746V31.3974L13.9937 14.8263C14.1393 13.4892 15.518 13.1178 17.8951 12.6691C19.7522 12.2977 22.3491 11.9619 24.6935 11.9619C27.2251 11.9619 29.2307 12.2234 30.5321 13.2277C31.4949 13.9319 32.0505 15.0462 32.0505 16.7933C32.0505 17.7976 31.8603 18.9118 31.7563 19.9132",
    fill: "#202735"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovicashStorePin);
export default __webpack_public_path__ + "static/media/NovicashStorePin.44b48042066a5871893597ea02b45dea.svg";
export { ForwardRef as ReactComponent };